<template>
  <div id="app">

    <ug-programmes 
      :ugProgrammes="ugProgrammes" 
      v-if="level === 'ug'"
      :loading="loading"
      :level.sync="level"
      />

    <pg-programmes 
      :pgProgrammes="pgProgrammes" 
      v-if="level === 'pg'"
      :loading="loading"
      :level.sync="level"
      />

  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Programmes from './components/Programmes.vue'
import UgProgrammes from './components/UgProgrammes.vue'
import PgProgrammes from './components/PgProgrammes.vue'

import axios from 'axios'

var currentUrl = window.location.href;
// console.log(currentUrl, currentUrl.includes("cms"));
const pgProgUrl = 'https://www.wgtn.ac.nz/endpoints/pg-subjects'
const ugProgUrl = currentUrl.includes("cms") ? 'https://cms.wgtn.ac.nz/endpoints/ug-subjects' : 'https://www.wgtn.ac.nz/endpoints/ug-subjects';


if (currentUrl.includes("cms")) {
  console.log(`Using ${ugProgUrl} for UG endpoint`);
}

//for local
// const pgList = require('./assets/pg.json')
// const ugList = require('./assets/ug.json')

//for prod
// const pgList = window.pg
// const ugList = window.ug

// console.log('pglist', pgList);
// console.log('uglist', ugList);

export default {
  name: 'app',
  components: {
    // HelloWorld,
    Programmes,
    UgProgrammes,
    PgProgrammes
  },
  data () {
    return {
      loading: true,
      ugProgrammes: [],
      pgProgrammes: [], 
      level: ''
    }
  },
  computed: {
    levelSet() {
      return (this.level == 'ug') ? 'Postgraduate' : 'Undergraduate';
    }
  },
  methods: {
    fetchData () {
      console.log('fetching data...');
      axios.all([ 
        axios.get(pgProgUrl),
        axios.get(ugProgUrl)
      ])
        .then( ([pg, ug]) => {
          console.log('UGENDPOINT',ug.data.items);
          console.log('PG ENDPOINT',pg.data.items);

          var uniq = {}
          
          const ugRemoveDups = ug.data.items.filter(obj => !uniq[obj.name] && (uniq[obj.name] = true));

          // console.log(ugRemoveDups);
          
          this.ugProgrammes = ugRemoveDups
          this.pgProgrammes = pg.data.items
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => this.loading = false)

    },
    setLevel () {
      // this.level = 'pg'
      this.level = window.level
      console.log('Level is ', this.level )
      
    },
    switchLevel () {
      (this.level == 'ug') ? this.level = 'pg' : this.level = 'ug';
    }
  },
  mounted () {
    this.fetchData()
    this.setLevel()
  }
}
</script>

<style lang="scss">
  #app {

    .programmes-wrap > .block {
      padding-top: 0;
    }

    .c-stack-body {
      .meta--labelled {
        margin-bottom: 0;
      }
    }
    .c-stack-code {
      font-size: 1.2rem;
    }

    .c-stack-short {
      flex-direction: column;
      
      .c-stack-fig {
        width: 100%;
        border-right: none;
        max-width: none;
        min-width: none;
      }
      .c-stack-code,
      .c-stack-title,
      .c-stack-intro {
        margin-bottom: 0.5rem;
      }

      .meta--labelled {
        margin-top: 1rem;
      }

      .meta-item {
        margin-bottom: 0;
        margin-right: 2rem;
        flex: 0 1 auto;

        display: flex;
        align-items: baseline;

        .meta-label {
          margin-right: 1rem;
          margin-bottom: 0;
        }
      }

      @media (max-width: 42.99em) {
        .c-stack-fig {
          width: auto;

          .c-stack-code {
            margin-bottom: 0;
          }
        }

        .meta-item {
          align-items: initial;
        }
      }

    }

  }
</style>
